/*
  Sticky add-to-cart bar. Mirrors the real Add to Cart button rather than
  duplicating the product form, so variant changes, sold-out states and any
  app hooking the form keep working.
*/
(function () {
  var bar = document.querySelector('.sticky-atc');
  if (!bar) return;

  var realButton = document.querySelector('product-form button[type="submit"], .product-form__submit');
  if (!realButton) {
    bar.remove();
    return;
  }

  var proxyButton = bar.querySelector('[data-sticky-atc-button]');
  var priceEl = bar.querySelector('[data-sticky-atc-price]');

  // Size validation (review #15): with nothing chosen, send the buyer back to
  // the size row and say so, instead of adding whatever Dawn preselected.
  var sizeRow = document.querySelector('.fm-size-row');
  var notice = bar.querySelector('[data-sticky-atc-notice]');

  function sizeChosen() {
    var pills = document.querySelectorAll('.product-form__input--pill');
    if (!pills.length) return true;
    for (var i = 0; i < pills.length; i++) {
      if (!pills[i].querySelector('input[type="radio"]:checked')) return false;
    }
    return true;
  }

  proxyButton.addEventListener('click', function () {
    if (!sizeChosen()) {
      if (sizeRow) {
        sizeRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeRow.classList.add('fm-size-row--attention');
        setTimeout(function () { sizeRow.classList.remove('fm-size-row--attention'); }, 1600);
      }
      if (notice) { notice.hidden = false; setTimeout(function () { notice.hidden = true; }, 2500); }
      return;
    }
    realButton.click();
  });

  // Sit above the promo bar when it's showing, rather than on top of it.
  function offset() {
    var promo = document.querySelector('.promo-bottom-bar:not([hidden])');
    bar.style.bottom = promo ? promo.getBoundingClientRect().height + 'px' : '0px';
  }
  new MutationObserver(offset).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
  window.addEventListener('resize', offset);
  offset();

  // Mirror label + disabled state (variant switches, sold out).
  function mirror() {
    var disabled = realButton.hasAttribute('disabled');
    proxyButton.disabled = disabled;
    var label = realButton.querySelector('span');
    if (label) proxyButton.textContent = label.textContent.trim();

    var livePrice = document.querySelector('.price__container .price-item--regular, .price-item--sale');
    if (livePrice && priceEl) priceEl.textContent = livePrice.textContent.trim();
  }
  new MutationObserver(mirror).observe(realButton, {
    attributes: true, childList: true, subtree: true
  });
  document.addEventListener('change', mirror);

  // Show the bar only once the real button is out of view.
  var visible = true;
  new IntersectionObserver(function (entries) {
    visible = entries[0].isIntersecting;
    update();
  }, { rootMargin: '0px 0px -80px 0px' }).observe(realButton);

  function cartOpen() {
    return document.body.classList.contains('qsc2-drawer-open') ||
      !!document.querySelector('cart-drawer.active, .qsc2-drawer-wrapper.is-open');
  }

  function update() {
    bar.hidden = visible || cartOpen();
  }

  new MutationObserver(update).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  mirror();
  update();
})();
